export default {
    ONIRIX_API_HOST: process.env.VUE_APP_ONIRIX_API_HOST,
    ONIRIX_HOST: process.env.VUE_APP_ONIRIX_HOST,
    API_TOKEN: process.env.VUE_APP_API_TOKEN,
    VUE_APP_HDBT_HOST: process.env.VUE_APP_HDBT_HOST,
    ENV: process.env.VUE_APP_ENV,
    GOOGLE_CLIENT_ID: process.env.VUE_APP_GOOGLE_CLIENT_ID,
}